import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import React, { useEffect, useState } from "react";
import OtpInput from "react-otp-input";
import { Button, Checkbox, Drawer, Form, Schema } from "rsuite";
import Swal from "sweetalert2";
import { eLoanStore } from "../../redux/store/eLoanApi";
import {
  currencyFormat,
  HideLoader,
  ShowLoader,
  toastError,
  toastSuccess,
  UserToken,
} from "../../utils/helper";
import Declaration from "./declaration";

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
const ALLOWED_FILE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/jpg",
  "application/pdf",
];

const ERROR_VALIDATION_MESSAGE = "This field is required";
const { StringType, NumberType, ObjectType } = Schema.Types;

const formValidation = (maxLoanAmount) =>
  Schema.Model({
    loanAmount: NumberType()
      .isRequired(ERROR_VALIDATION_MESSAGE)
      .max(maxLoanAmount, "Loan amount must not exceed " + maxLoanAmount)
      .min(5000, "The loan amount must be at least 5000"),
    bankName: StringType().isRequired(ERROR_VALIDATION_MESSAGE),
    bankAccountNo: StringType().isRequired(ERROR_VALIDATION_MESSAGE),
    accountHolderName: StringType().isRequired(ERROR_VALIDATION_MESSAGE),
    // files: ObjectType()
    //   .isRequired("Please upload a file (Image or PDF)")
    //   .addRule(
    //     (file) => file && file.size <= MAX_FILE_SIZE,
    //     "File size must be less than or equal to 5MB"
    //   )
    //   .addRule(
    //     (file) => file && ALLOWED_FILE_TYPES.includes(file.type),
    //     "Only JPG, JPEG, PNG, and PDF formats are allowed"
    //   ),
  });

export default function PolicyDetails(props) {
  const { openDrawer, setOpenDrawer, policyDetails, stepOneDetails } = props;
  const { post_saveEloanProposal, post_generateOTP } = eLoanStore();
  const [otp, setOtp] = useState("");
  const [declarationAccept, setDeclarationAccept] = useState("0");
  const [showOtpField, setShowOtpField] = useState(false);
  const [checked, setChecked] = useState(false);
  const [eloanProposal, setEloanProposal] = useState({});
  const [formValue, setFormValue] = useState({});
  const [base64Image, setBase64Image] = useState({
    documentName: "",
    documentFile: "",
    documentTitle: "",
  });

  const formRef = React.useRef();

  useEffect(() => {
    getFormValue();
  }, [policyDetails]);

  const getFormValue = () => {
    const previousLoan = policyDetails?.previousLoan?.find(
      (loan) => loan.status === "PENDING"
    );
    if (!previousLoan) {
      setFormValue({
        policyNo: "",
        mobileNo: "",
        dob: "",
        loanAmount: "",
        // attachments: "",
        bankName: policyDetails.bankName,
        bankAccountNo: policyDetails.bankAccountNo,
        accountHolderName: policyDetails.bankAccountName,
      });
    } else {
      setFormValue({
        policyNo: "",
        mobileNo: "",
        dob: "",
        loanAmount: Number(previousLoan.loanAmount).toFixed(0),
        // attachments: previousLoan.attachment.documentPath,
        accountHolderName: previousLoan.accountHoldername,
        bankAccountNo: previousLoan.bankAccountNo,
        bankName: previousLoan.bankName,
      });
    }
  };

  const openImageInModal = () => {
    Swal.fire({
      imageUrl: base64Image.documentFile
        ? "data:image/jpeg;base64," + base64Image.documentFile
        : formValue.attachments,
      imageWidth: "auto",
      imageHeight: 350,
      imageAlt: "Custom image",
      confirmButtonText: "Close",
      customClass: {
        confirmButton: "custom-swal-button",
        image: "rounded",
      },
    });
  };

  const handleSubmit = async (value) => {
    if (!formRef.current.check()) {
      console.error("Form Error");
      return;
    }

    // if (!base64Image.documentName && !formValue.attachments) {
    //   toastError("Please upload Cheque/Account details proof document.");
    //   return;
    // }

    const merge = {
      ...formValue,
      ...stepOneDetails,
      // attachments: base64Image?.documentName ? [base64Image] : null,
    };

    setEloanProposal(merge);

    Swal.fire({
      title: "Declaration",
      html: `
      <p class="text-start text-base"><span>आई.एम.ई लाइफ इन्स्योरेन्स कम्पनी लिमिटेड (यसपछि कम्पनी भनी उल्लेख भएको) बाट उल्लेखित बीमालेख कम्पनीमा मैले ऋण स्वरुप प्राप्त गर्ने रकम म स्वयं तथा मेरो उत्तराधिकारीको हकमा समेत कंम्पनी तथा कंम्पनीमा उत्तराधिकारीसंग देहाय बमोजिमको शर्त कबुलियत गरीदिएको छु ।</span></p>
<p class="text-start text-base"><span>१. बीमालेख अन्तर्गत मैले लिएको ऋणको सुरक्षणको लागि मेरो जीवन बीमालेखबाट सर्मपण मूल्यको ९० प्रतिशत सम्म रकम प्राप्त गर्ने बिषयमा म मञ्जुर गर्दछु ।</span></p>
<p class="text-start text-base"><span>२. ऋण रकम जुनसुकै समयमा पनि कम्पनीमा बुझाउने बिषयमा मेरो पुर्ण मञ्जुरी छ ।</span></p>
<p class="text-start text-base"><span>३. विवरणमा उल्लेख भए बमोजिमको वा समय समयमा कम्पनीले तोके बमोजिमको व्याज भुक्तानी गर्न मञ्जुर गर्दछु । प्रत्येक असार मसान्त पछि चुक्ता हुने गरि व्याज रकम सावा रकममा गणना गरिने बिषयमा मेरो पुर्ण मञ्जुरी छ । उल्लेखित व्याजदर समय समयमा परिर्वतन गर्न सकिने र परिवर्तित व्याजदर त्यस पछिको भुक्तानी मिति देखि मात्र लागु गर्ने बिषयमा मेरो पुर्ण मञ्जुरी छ ।&nbsp;</span></p>
<p class="text-start text-base"><span>४. कम्पनीले ऋण रकम फछ्र्यौट गर्नु भनी सूचना दिन सक्नेछ । सो सूचना पाएको ३० दिनभित्र साँवा र व्याज समेत जोड्दा हुने एक मुष्ट रकम कम्पनीको उल्लेखित कार्यालयमा बुझाउन मञ्जुर गर्दछु ।&nbsp;</span></p>
<p class="text-start text-base"><span>५. ऋण रकमको आंशिक भुक्तानी स्वीकार गर्न कम्पनी वा कम्पनीको उत्तराधिकार बाध्य हुने छैन ।&nbsp;</span></p>
<p class="text-start text-base"><span>६. यसरी बीमालेखबाट प्राप्त हुने कर्जामा लिएको ऋणको साँवा व्याज जोड्दा हुने रकम बीमालेख अन्तर्गतको सर्मपर्ण मुल्य बराबर वा सो भन्दा बढी भएमा वा बीमालेख व्यतित भएमा साँवा व्याज भुक्तानीको लागि बीमितलाई सूचना पठाइने छ । उक्त सूचना जारी भएको ३ महिनाभित्र पनि सो रकम भुक्तानी नगरेमा बीमालेख जफत गरी सो को सम्पूर्ण मूल्यवाट साँवा व्याज असुल उपर गरी कुनै रकम बढी भएमा बीमित वा निजको हकवालालाई भुक्तानी गरीने बिषयमा मेरो पुर्ण मञ्जुरी छ ।&nbsp;&nbsp;&nbsp;</span></p>
<p class="text-start text-base"><span>७. बीमालेख अन्तर्गत प्रदान गरेको ऋणको साँवा तथा व्याज पूर्ण वा आंशिक भुक्तानी नहुँदै बीमालेखको शर्त अनुसार मृत्यु दाबी वा बीमा अवधि समाप्त भई अवधि दाबी भुक्तानी गर्नुपर्ने भएमा दाबी रकम मध्ये बाट बीमितबाट असुल उपर हुन बाँकी ऋण र सोको व्याज कट्टा गरी बाँकी रकम मात्र बीमालेख अन्तर्गत भुक्तानी गर्ने बिषयमा मेरो पुर्ण सहमती छ ।&nbsp;</span></p>
<p class="text-start text-base"><span>८. व्याजको विवरणहरु :</span></p>
<p class="text-start text-base"><span>क) व्याज १०% प्रतिशत प्रति बर्षका दरले लिईनेछ ।&nbsp;</span></p>
<p class="text-start text-base"><span>ख) पहिलो व्याजको भुक्तानी ऋण लिएको मिति पछिको आषाढ मसान्त हुनेछ ।&nbsp;</span></p>
<p class="text-start text-base"><span>ग) त्यस पछिको व्याजको भु्क्तानी ऋण कट्टी नहुन्जेल प्रत्येक आषाढ मसान्तमा हुनेछ ।&nbsp;</span></p>
<p class="text-start text-base"><span>९. जीवन बीमालेखको शर्त बमोजिम यदी कुनै अवस्थामा तपाईले लिनुभएको ऋण रकम र तिर्न बाँकी व्याज समर्पण मूल्यभन्दा बढी भएमा बीमालेख जफत गरी ऋण र तिर्न बाँकी व्याज असुल उपर गरीने छ ।&nbsp;</span></p>
<p class="text-start text-base"><span>नेपालको बीमा नियामक निकायद्वारा जारी निर्देशन तथा कानुनको पालना तथा शर्तहरुको पूर्ण पालना गनेमा म स्वंयले मञ्जुुर गर्दछु । साथै माथि उल्लेखित शर्तहरु आफ्नो मनोमानी राजीखुशीले स्वीकार गरी उल्लेखित ऋण त्यसको व्याज र सम्बन्धीत खर्च समेतको रहेको बीमालेख आजका मितिमा साहु कम्पनी श्री आई.एमं.ई लाइफ इन्स्योरेन्स कम्पनी लिमिटेड र कम्पनीका उत्तराधिकारीलाई कम्पनीको कर्पोरेट तथा रजिष्टर्ड कार्यालय का.जि.का.म.न.पा. वडा नं.२६</span><strong>, </strong><span>लैनचौंर</span><strong>, </strong><span>काठमाण्डौंमा बुझाइदिएँ ।&nbsp;</span></p>
    `,
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "I agree",
      denyButtonText: "Cancel",
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        await UserToken();
        post_generateOTP(stepOneDetails)
          .then((res) => {
            if (res.code === "100") {
              setDeclarationAccept("1");
              // setTimeout(() => {
                setShowOtpField(true);
              // }, 500);
              toastSuccess(
                "OTP has been sent to your mobile number. Please enter the OTP."
              );
            } else {
              Swal.fire({
                title: "Failed",
                text: "OTP can't be sent. Please contact to support team.",
                icon: "question",
                confirmButtonColor: "#d33",
              });
            }
          })
          .catch(() => {
            toastError("OTP can't be sent. Please contact to support team.");
          });
      }
    });
  };

  const verifyOTP = (otp) => {
    ShowLoader();
    eloanProposal.otp = otp;
    eloanProposal.DeclarationRead = declarationAccept;

    UserToken();
    post_saveEloanProposal(eloanProposal)
      .then((res) => {
        if (res.code === "100") {
          Swal.fire({
            title: "Completed",
            html: "Your loan application has been successfully submitted.<br><br>For any queries, please contact:<br>+977 01 4024071 or info@imelifeinsurance.com",
            icon: "success",
            confirmButtonText: "Close",
            confirmButtonColor: "#E51D25",
          }).then(() => {
            closeDrawer();
            window.location.reload();
          });
          return;
        }
        Swal.fire({
          title: "Failed",
          text: res.message || "API Error! Please contact to support team.",
          icon: "question",
          confirmButtonColor: "#d33",
        });
        return;
      })
      .catch((err) => {})
      .finally(() => HideLoader());
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        const cleanBase64 = base64String.split(",")[1];
        setBase64Image({
          documentFile: cleanBase64,
          documentName: file.name,
          documentTitle: file.name,
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const closeDrawer = () => {
    setOpenDrawer(false);
    setChecked(false);
    setShowOtpField(false);
  };

  return (
    <>
      <Drawer
        size={"full"}
        placement="bottom"
        backdrop="static"
        open={openDrawer}
        onClose={closeDrawer}
        style={{ top: 0, height: "100vh" }}
      >
        <Drawer.Header>
          <Drawer.Title>E-loan details</Drawer.Title>
          <Drawer.Actions>
            <Button
              appearance="primary"
              className="btn-primary"
              onClick={closeDrawer}
            >
              Cancel
            </Button>
          </Drawer.Actions>
        </Drawer.Header>
        <Drawer.Body className="p-3 lg:p-5 xl:px-10">
          {Object.keys(policyDetails).length > 0 && (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
              <div>
                <div className="mb-2 grid grid-cols-2">
                  <div className="font-semibold fs-5 mb-1 bg-gray-100 py-1 px-3 rounded-l">
                    Policy No.
                  </div>
                  <div className="font-semibold fs-5 mb-1 bg-gray-100 py-1 px-3 rounded-r">
                    {policyDetails.policyNo}
                  </div>
                  <div className="font-semibold fs-5 mb-1 bg-gray-100 py-1 px-3 rounded-l">
                    Insured Name
                  </div>
                  <div className="font-semibold fs-5 mb-1 bg-gray-100 py-1 px-3 rounded-r">
                    {policyDetails.insuredName}
                  </div>
                  <div className="font-semibold fs-5 mb-1 bg-gray-100 py-1 px-3 rounded-l">
                    Product Name
                  </div>
                  <div className="font-semibold fs-5 mb-1 bg-gray-100 py-1 px-3 rounded-r">
                    {policyDetails.productName}
                  </div>
                  <div className="font-semibold fs-5 mb-1 bg-gray-100 py-1 px-3 rounded-l">
                    Sum Assured
                  </div>
                  <div className="font-semibold fs-5 mb-1 bg-gray-100 py-1 px-3 rounded-r">
                    {currencyFormat(Number(policyDetails.sumAssured))}
                  </div>
                  <div className="font-semibold fs-5 mb-1 bg-gray-100 py-1 px-3 rounded-l">
                    Premium
                  </div>
                  <div className="font-semibold fs-5 mb-1 bg-gray-100 py-1 px-3 rounded-r">
                    {currencyFormat(Number(policyDetails.premium))}
                  </div>
                  <div className="font-semibold fs-5 mb-1 bg-gray-100 py-1 px-3 rounded-l">
                    Term | MOP
                  </div>
                  <div className="font-semibold fs-5 mb-1 bg-gray-100 py-1 px-3 rounded-r">
                    {policyDetails.term} | {policyDetails.mop}
                  </div>
                  <div className="font-semibold fs-5 mb-1 bg-gray-100 py-1 px-3 rounded-l">
                    DOC | Maturity Date
                  </div>
                  <div className="font-semibold fs-5 mb-1 bg-gray-100 py-1 px-3 rounded-r">
                    {moment(policyDetails.doc).format("YYYY-MM-DD")} |{" "}
                    {moment(policyDetails.maturityDate).format("YYYY-MM-DD")}
                  </div>
                  <div className="font-semibold fs-5 mb-1 bg-gray-100 py-1 px-3 rounded-l">
                    Instalment
                  </div>
                  <div className="font-semibold fs-5 mb-1 bg-gray-100 py-1 px-3 rounded-r">
                    {policyDetails.instalment}
                  </div>
                  <div className="font-semibold fs-5 mb-1 bg-gray-100 py-1 px-3 rounded-l">
                    Next Due Date
                  </div>
                  <div className="font-semibold fs-5 mb-1 bg-gray-100 py-1 px-3 rounded-r">
                    {moment(policyDetails.nextDueDate).format("YYYY-MM-DD")}
                  </div>
                </div>

                {policyDetails.previousLoan.length > 0 &&
                  policyDetails.previousLoan.map((loan, index) => (
                    <>
                      <div className="font-semibold text-lg mb-2">
                        Prevoius Loan List
                      </div>

                      <div
                        className="border border-gray-400 border-dashed rounded p-3 mb-3"
                        style={
                          loan.isLoanApproved === "0"
                            ? { backgroundColor: "#fff8dd" }
                            : { backgroundColor: "#e8fff3" }
                        }
                      >
                        <div className="grid grid-cols-2">
                          <div className="font-semibold fs-5">Loan Amount</div>
                          <div className="font-semibold fs-5">
                            {currencyFormat(Number(loan.loanAmount))}
                          </div>
                          <div className="font-semibold fs-5">
                            Loan Applied Date
                          </div>
                          <div className="font-semibold fs-5">
                            {moment(loan.loanDate).format("YYYY-MM-DD")}
                          </div>
                          <div className="font-semibold fs-5">Bank Name</div>
                          <div className="font-semibold fs-5">
                            {loan.bankName}
                          </div>
                          <div className="font-semibold fs-5">
                            Bank Account No.
                          </div>
                          <div className="font-semibold fs-5">
                            {loan.bankAccountNo}
                          </div>
                          <div className="font-semibold fs-5">Status</div>
                          <div className="font-semibold fs-5">
                            <span className="font-semibold">
                              {loan.status}
                            </span>
                          </div>
                        </div>
                      </div>
                    </>
                  ))}

                <div className="font-semibold text-lg mb-2">Available Loan</div>

                <div className="border border-gray-400 border-dashed rounded p-3">
                  <div className="grid grid-cols-2 items-center">
                    <div className="font-semibold fs-5">Online Loan Limit</div>
                    <div className="font-semibold fs-5 text-gray-700">
                      <div
                        className="text-base py-1 px-3 text-white"
                        style={{ backgroundColor: "#8FBE22" }}
                      >
                        {currencyFormat(
                          Number(policyDetails.availableLoanAmount)
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <Form
                  fluid
                  ref={formRef}
                  model={formValidation(policyDetails.availableLoanAmount)}
                  formValue={formValue}
                  onChange={setFormValue}
                  onSubmit={handleSubmit}
                  className="bg-gray-100 rounded p-5"
                  disabled={showOtpField}
                >
                  {showOtpField ? (
                    <div className="py-10">
                      <div className="text-base text-center mb-3">
                        A verification code has been sent to your mobile number{" "}
                        <span className="font-semibold">
                          {stepOneDetails.mobileNo}
                        </span>
                        . Please enter the code below to continue.
                      </div>
                      <OtpInput
                        value={otp}
                        onChange={(e) => {
                          setOtp(e);
                          if (e.length === 6) {
                            verifyOTP(e);
                          }
                        }}
                        numInputs={6}
                        renderSeparator={<span className="mx-1">-</span>}
                        renderInput={(props) => <input {...props} />}
                        inputStyle={{
                          width: "40px",
                          height: "40px",
                          border: "1px solid #e5e5ea",
                          borderRadius: "5px",
                        }}
                        containerStyle={{ justifyContent: "center" }}
                      />
                    </div>
                  ) : (
                    <div className="">
                      <Form.Group controlId="loanAmount">
                        <Form.ControlLabel>Loan Amount</Form.ControlLabel>
                        <Form.Control name="loanAmount" />
                      </Form.Group>

                      <Form.Group controlId="bankName">
                        <Form.ControlLabel>Bank Name</Form.ControlLabel>
                        <Form.Control name="bankName" disabled />
                      </Form.Group>

                      <Form.Group controlId="bankAccountNo">
                        <Form.ControlLabel>Bank Account No.</Form.ControlLabel>
                        <Form.Control name="bankAccountNo" disabled />
                      </Form.Group>

                      <Form.Group controlId="accountHolderName">
                        <Form.ControlLabel>
                          Account Holder Name
                        </Form.ControlLabel>
                        <Form.Control name="accountHolderName" disabled />
                      </Form.Group>

                      {/* <Form.Group controlId="attachments">
                      <Form.ControlLabel>
                        Upload Cheque/Account details proof
                      </Form.ControlLabel>
                      <div className="flex items-center justify-between border border-gray-300 rounded-lg p-2 bg-white">
                        <input
                          type="file"
                          name="attachments"
                          accept="image/*"
                          onChange={(event) => handleFileChange(event)}
                          disabled={showOtpField}
                        />
                        <FontAwesomeIcon
                          icon={faEye}
                          size="lg"
                          onClick={openImageInModal}
                          className="cursor-pointer"
                        />
                      </div>
                    </Form.Group> */}
                      {/* <Form.Group> */}
                      <Checkbox
                        onChange={(value, checked) => setChecked(checked)}
                        className="mb-3"
                      >
                        I hereby confirm that the above information is correct
                        to the best of my knowledge and belief.
                      </Checkbox>
                      {/* </Form.Group> */}
                      <Form.Group>
                        <Button
                          appearance="primary"
                          className="btn-primary"
                          type="submit"
                          disabled={!checked}
                        >
                          Submit
                        </Button>
                      </Form.Group>
                    </div>
                  )}
                </Form>
              </div>
            </div>
          )}
        </Drawer.Body>
      </Drawer>

      <Declaration />
    </>
  );
}
